import { render, staticRenderFns } from "./ApplicationWithUpdate.vue?vue&type=template&id=8732737e&scoped=true&"
import script from "./ApplicationWithUpdate.vue?vue&type=script&lang=js&"
export * from "./ApplicationWithUpdate.vue?vue&type=script&lang=js&"
import style0 from "./ApplicationWithUpdate.vue?vue&type=style&index=0&id=8732737e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8732737e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VCardSubtitle,VCardTitle,VHover,VIcon})
